import type { SerializedRichText } from './types'

// Lightweight version of isSerializedRichText
// that doesn't need React or the entire zod schema

export default function isSerializedRichTextProbably(value: unknown): value is SerializedRichText {
  return (
    typeof value === 'object' &&
    value !== null &&
    'serialization_method' in value &&
    'content' in value &&
    (value.serialization_method === 'slate_json_v1' ||
      value.serialization_method === 'plain_text' ||
      value.serialization_method === 'raw_html')
  )
}
